import { render, staticRenderFns } from "./RegisterPromoAgent.vue?vue&type=template&id=d895dc62&scoped=true&"
import script from "./RegisterPromoAgent.vue?vue&type=script&lang=js&"
export * from "./RegisterPromoAgent.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPromoAgent.vue?vue&type=style&index=0&id=d895dc62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d895dc62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
